"use strict";

var urlHelper = require("../helpers/urlHelpers");

/**
* Updates the browser's URL to reflect the current pagination state by modifying the "sz" and "start" query parameters.
* Utilizes the History API to push the updated URL without reloading the page.
*
* @param {string} pageUrl - The URL containing the pagination query parameters ("sz" for page size and "start" for start index).
*/
function updateWindowUrl(pageUrl) {
    var sz = pageUrl ? urlHelper.getQueryStringValue(pageUrl, "sz") : null;
    var start = pageUrl ? urlHelper.getQueryStringValue(pageUrl, "start") : null;

    if (sz && start) {
        var windowUrl = window.location.href;

        windowUrl = urlHelper.insertParam(windowUrl, "start", start);
        windowUrl = urlHelper.insertParam(windowUrl, "sz", sz);

        window.history.pushState(null, null, windowUrl);
    }
}

/**
* Attaches a click event handler to the "Show More" pagination button within the product search container.
* When triggered, it performs an AJAX request to load additional product results, updates the product grid,
* manages browser history state for pagination, updates sorting and pagination controls, and scrolls to the top of the page.
* Also handles spinner display during the asynchronous operation and updates the displayed count of loaded products.
*
* @fires search:showMore - Triggered before the AJAX request to allow for additional event handling.
* @listens click - Listens for clicks on elements with the '.btn-page' class inside '.container'.
* @returns {void}
*/
function showMore() {
    $(".container").on("click", ".btn-page", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $.spinner().start();

        var pageLinkUrl = $(this).data("url");

        if (pageLinkUrl) {
            $.ajax({
                url: pageLinkUrl,
                data: { selectedUrl: pageLinkUrl },
                method: "GET",
                success: function (response) {
                    $(".product-grid").html(response);
                    updateWindowUrl(pageLinkUrl);
                    $("html, body").animate({scrollTop: 0}, 400);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
* Expands refinement sections that contain selected options by adding the 'active' class.
* Iterates over all elements with the 'refinement' class and checks if any child element has the 'selected' class.
* If a selected option is found, the parent refinement section is marked as active.
*
* @returns {void}
*/
function keepRefinementsExpanded() {
    $(".refinement").each(function () {
        var $toggle = $(this);
        var hasSelected = $toggle.find(".selected").length > 0;

        if (hasSelected) {
            $toggle.addClass("active");
        }
    });
}

export default function search() {
    showMore();
    keepRefinementsExpanded();
}
